<template>
    <v-app>
        <header-card-public current_page="ChangePassword"></header-card-public>
        <v-content class="bg-container">
            <v-layout fill-height row wrap>
                <!-- Left/top Side: Ads -->
                <v-flex v-if="!isMobile" xs12 sm6 class="ads-section">
                    <div class="ads-bg">
                        <public-notifications></public-notifications>
                    </div>
                </v-flex>
                <v-flex xs12 sm6 :class="welcomeSectionClass">
                    <v-layout fill-height align-center justify-center>
                        <div class="login-container">
                            <v-card  class="mx-auto login-card" max-width="550">
                                <v-form @submit.prevent="executeRecaptcha" ref="formChangePassword">
                                    <v-card-text>
                                        <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                                            {{ errorMessage }}
                                        </v-alert>
                                        <v-layout row wrap>
                                        <v-flex xs12 class="mr-15 ml-15"> 
                                            <h3 class="text-xs-center">CHANGE PASSWORD</h3>  

                                            <p class="mt-10 primary--text">
                                                Your password must be at least 12 characters and include uppercase, lowercase, number, and special character. Tip: Use a memorable phrase (e.g., SunsetsAreBetter@Boracay2024).
                                            </p>

                                            <v-alert v-if="password_the_same" :value="true" color="error" icon="error" outline>
                                                {{dbresult_description}}
                                            </v-alert>

                                            <v-alert v-if="notthesamepassword" :value="true" color="error" icon="error" outline>
                                                Input passwords are not the same.
                                            </v-alert>
                                            
                                            <v-text-field 
                                                v-model="pass1" 
                                                :rules="[rules.required, rules.min, rules.strong_password]" 
                                                label="Password"
                                                hint="At least 12 characters"
                                                counter
                                                :disabled="disabled"
                                                autocomplete="new-password"
                                                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                                                :type="show1 ? 'text' : 'password'"
                                                @click:append="show1 = !show1"
                                                @blur="password_the_same=false"
                                                >
                                            </v-text-field>

                                            <v-text-field 
                                                v-model="pass2" 
                                                :rules="[rules.required, rules.min, rules.strong_password]" 
                                                label="Confirm Password"
                                                hint="At least 12 characters"
                                                counter
                                                :disabled="disabled"
                                                autocomplete="new-password"
                                                :append-icon="show2 ? 'visibility_off' : 'visibility'"
                                                :type="show2 ? 'text' : 'password'"
                                                @click:append="show2 = !show2"
                                                @blur="password_the_same=false"
                                                >
                                            </v-text-field>
                                        </v-flex>
                                        </v-layout> 
                                    </v-card-text>  
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-spacer></v-spacer>
                                        <v-btn dark :color="welcomeButtonColor" type="submit" :loading="loading">Ok</v-btn>
                                        <v-btn @click="$router.go(-1)" :disabled="disabled" class="mr-20">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </div>
                        <div class="footer-section caption">
                            <div class="white--text text-xs-center">&copy; Copyright 2024 SweldoNow OPC. All Rights Reserved.</div>
                            <other-legal-docs v-if="!isMobile"></other-legal-docs>
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-content>

        <recaptcha ref="recaptcha" @verify="submitReCaptcha"></recaptcha>

        <v-dialog v-model="dialogOkOnly" persistent width="600">
            <ok-only :msg="dialogOkOnlyMsg" :dialogOkOnly.sync="dialogOkOnly" @ok="login"></ok-only>
        </v-dialog>
    </v-app>
</template>
<script>

import '@/assets/css/public.css'
import '@/assets/css/season.css'
import userApi from '@/api/user.js'
import Recaptcha from '@/components/ReCaptcha.vue'
import auth from '@/auth/auth.js'
import commonfn from '@/common/functions.js'    // for refactor
import publicPages from '@/helpers/public-pages.js'

export default {
    name: 'ChangePassword',
    metaInfo: {
        title: 'Change Password',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Password change on first login or after password reset' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        Recaptcha,
        'other-legal-docs': () => import('@/components/Common/OtherLegalDocs'),
        'header-card-public': () => import('@/components/Common/HeaderPublic'),
        'public-notifications': () => import('@/components/PublicNotifications/PublicNotifications'),
        'ok-only': ()=> import("@/components/BasicPopups/OkOnly"),
    },
    data () {
        return {
            dialog: false,
            disabled: false,       
            loading: false,
            email: '',         
            error: false,  
            errorMessage: '',
            oldPassword: '',
            pass1: '', 
            pass2: '',
            show1: false,
            show2: false,
            showOld: false,
            //todo - put this in rules-helper.js
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 12 || 'Min 12 characters',
                counter: value => value.length <= 50 || 'Max 50 characters',
                strong_password: value => {
                    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
                    return pattern.test(value) || 'Must contain at least 1 lower case, 1 upper case, 1 numeric, 1 special character.'
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                } 
            },
            recaptchaResponse: null,
            dbresult_description: null,
            password_the_same: false,
            dialogOkOnly: false,
            dialogOkOnlyMsg: 'Your password has been successfully changed. You can now proceed to log in.',
        }
    },   
    methods: {
        submitReCaptcha(response) {
            this.recaptchaResponse = response
            this.changePassword()
        },       
        executeRecaptcha() {
            if ((this.$refs.formChangePassword.validate()) && (!this.notthesamepassword)) {
                this.loading = true
                this.disabled = true
                this.$refs.recaptcha.execute()
            }
        },
        login() {
            const logoutData = {
                userId: this.$store.state.userId,
                logoutCode: "change_password",
                logoutMessage: "Change Password",
            }
            auth.logout(logoutData)

            this.dialogOkOnly = false

            this.$router.push({
                path: '/Login',
                query: { redirect: this.$route.query.redirect }
            });
        },
        clear() {
            this.$refs.formChangePassword.reset()
            this.loading = false
            this.error = false
        },
        async changePassword() {
            this.error = false

            // Check validation first to avoid unnecessary try/catch overhead
            if (!this.$refs.formChangePassword.validate() || this.notthesamepassword) {
                return
            }

            try {
                this.loading = true
                this.disabled = true

                const response = await userApi.changePassword(
                    this.userId, 
                    this.pass1, 
                    this.recaptchaResponse
                )
                
                if (response && response.status == 200) {     
                    this.dbresult_description = commonfn.validateDBResponse(response.data);
                    
                    if (!this.dbresult_description) {
                        this.clear()
                        this.dialogOkOnly = true
                    } else {
                        // Handle cases where password might be the same as old one, etc.
                        this.password_the_same = true
                        this.loading = false
                        this.disabled = false
                    }  
                }
            } catch(error) {
                this.error = true
                // Use a consistent error parser or check for response data
                this.errorMessage = error.response && error.response.data 
                    ? error.response.data.message 
                    : error.message || "An error occurred";
                
                if (!this.errorMessage) this.errorMessage = error

                this.loading = false
                this.disabled = false
            }
        }
    },
    mounted() {
        // Check the route params for the flag
        const isInitiatedBySystem = this.$route.params.fromLoginFlow

        if (!isInitiatedBySystem) {
            //prevent from manually accessing change password page
            return this.$router.push({
                path: '/home',
                query: { redirect: this.$route.query.redirect }
            });
        }
        
        // Only reset if the ref exists
        if (this.$refs.formChangePassword) {
            this.$refs.formChangePassword.reset();
        }
    },
    computed: {
        userId() {
            return this.$store.state.userId
        },
        notthesamepassword: function() {
            if (this.pass1 && this.pass2)
                return this.pass1!=this.pass2
        },
        seasonDetails() {
            return publicPages.getSeasonDetails(this.$route.query.action, this.isMobile);
        },
        welcomeSectionClass() {
            return this.seasonDetails.className;
        },
        welcomeButtonColor() {
            return this.seasonDetails.buttonColor;
        },
    },
    created() {}
}
</script>
